import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min';
import React from 'react';
import ReactDOM from 'react-dom';
import './styles.scss';
import App from './App';
import Amplify, { API, Auth } from "aws-amplify";
import awsExports from "./aws-exports";
Amplify.configure(awsExports);
// if(!process.env.REACT_APP_TITLE.includes('Dev')){
//   // Remove Logs if environment not dev
//   console.log = function(){}
//   // Add OTP if environment not dev
//   Auth.configure({
//     authenticationFlowType: 'CUSTOM_AUTH',
//   })
// }

API.configure({
  endpoints: [
    {
      name: "SECURITY_SERVICE",
      endpoint: process.env.REACT_APP_SECURITY_SERVICE_ENDPOINT
    },
    {
      name: "USER_SERVICE",
      endpoint: process.env.REACT_APP_USER_SERVICE_ENDPOINT
    },
    {
      name: "LISTING_SERVICE",
      endpoint: process.env.REACT_APP_LISTING_SERVICE_ENDPOINT
    },
    {
      name: "SECONDARY_MARKET_SERVICE",
      endpoint: process.env.REACT_APP_SECONDARY_MARKET_SERVICE_ENDPOINT
    },
    {
      name: "REPORTS_SERVICE",
      endpoint: process.env.REACT_APP_REPORTS_SERVICE_ENDPOINT
    }
  ]
});

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);

